import * as React from 'react';

import TextButton from '@/components/elements/Button/TextButton';

import { DeleteAllArea } from './style';

interface DeleteAllButtonProps {
  openModal: () => void;
}

const DeleteAllButton: React.FC<DeleteAllButtonProps> = React.memo(
  ({ openModal }) => {
    return (
      <DeleteAllArea>
        <TextButton size="s" hoverEffect="highlight" onClick={openModal}>
          買い目を全て削除する
        </TextButton>
      </DeleteAllArea>
    );
  },
);

export default DeleteAllButton;
